<template>
  <b-card no-body>
    <div class="row p-2 align-items-end">
      <div class="col-md-3 mb-1">
        <label class="form-label">Başlangıç Tarihi</label>
        <input
          v-model="startDate"
          type="date"
          class="form-control"
        >
      </div>
      <div class="col-md-3 mb-1">
        <label class="form-label">Bitiş Tarihi</label>
        <input
          v-model="endDate"
          type="date"
          class="form-control"
        >
      </div>
      <div class="col-md-3 mb-1">
        <label class="form-label">Kullanıcı Tipi</label>
        <select
          v-model="userType"
          class="form-control"
        >
          <option :value="null">
            Tümü
          </option>
          <option :value="1">
            Personel
          </option>
          <option :value="2">
            Müşteri
          </option>
        </select>
      </div>
      <div class="col-md-3 mb-1">
        <v-executer :action="applyFilters">
          Filtrele
        </v-executer>
      </div>
    </div>

    <b-tabs
      v-model="activeTab"
      class="px-2 pb-2"
      content-class="mt-2"
    >
      <!-- En çok ziyaret edilen ekranlar -->
      <b-tab
        title="En Çok Kullanılan Ekranlar"
        active
      >
        <p class="text-muted px-1 mb-1">
          Aralıktaki toplam ziyaret: <strong>{{ screensTotalViews }}</strong>
        </p>
        <v-table
          ref="screensTable"
          :items-provider="screensProvider"
          :fields="screensFields"
          pagination="server"
          row-slot="in"
          search
        >
          <template #row="{ row }">
            <td>{{ row.PageTitle || row.RouteName || row.RoutePath }}</td>
            <td>{{ row.ViewCount }}</td>
            <td>{{ row.UniqueUserCount }}</td>
            <td>{{ formatDuration(row.AvgDurationSeconds) }}</td>
            <td>{{ formatDuration(row.AvgActiveSeconds) }}</td>
            <td>{{ formatDuration(row.TotalActiveSeconds) }}</td>
          </template>
        </v-table>
      </b-tab>

      <!-- Kullanıcı aktivitesi -->
      <b-tab title="Kullanıcı / Müşteri Aktivitesi">
        <p class="text-muted px-1 mb-1">
          "Ekran Geçmişi" düğmesiyle o kullanıcının gün içi ekran hareketlerini görebilirsiniz.
        </p>
        <v-table
          ref="usersTable"
          :items-provider="usersProvider"
          :fields="usersFields"
          :buttons="userButtons"
          pagination="server"
          row-slot="in"
          search
        >
          <template #row="{ row }">
            <td>{{ row.UserFullName || row.CustomerCode || '—' }}</td>
            <td>{{ userTypeLabel(row.UserType) }}</td>
            <td>{{ row.ScreenViewCount }}</td>
            <td>{{ row.SessionCount }}</td>
            <td>{{ formatDuration(row.TotalActiveSeconds) }}</td>
            <td>{{ formatDuration(row.TotalDurationSeconds) }}</td>
            <td>{{ formatDate(row.LastSeen) }}</td>
          </template>
        </v-table>
      </b-tab>

      <!-- Ekran geçiş akışı -->
      <b-tab title="Ekran Geçiş Akışı">
        <v-table
          ref="flowTable"
          :items-provider="flowProvider"
          :fields="flowFields"
          pagination="server"
          row-slot="in"
          search
        >
          <template #row="{ row }">
            <td>{{ row.FromRouteName || row.FromRoutePath }}</td>
            <td>{{ row.ToRouteName || row.ToRoutePath }}</td>
            <td>{{ row.Count }}</td>
          </template>
        </v-table>
      </b-tab>

      <!-- Kullanıcı bazlı ekran geçmişi (zaman çizelgesi) -->
      <b-tab title="Kullanıcı Ekran Geçmişi">
        <p
          v-if="!selectedUser"
          class="text-muted px-1"
        >
          "Kullanıcı / Müşteri Aktivitesi" sekmesinden bir kullanıcının "Ekran Geçmişi" düğmesine tıklayın.
        </p>
        <div v-else>
          <p class="px-1 mb-1">
            <strong>{{ selectedUser.UserFullName || selectedUser.CustomerCode }}</strong>
            — {{ timelineScreenCount }} ekran, toplam aktif süre
            <strong>{{ formatDuration(timelineActiveSeconds) }}</strong>
            ({{ formatDuration(timelineDurationSeconds) }} toplam)
          </p>
        </div>
        <v-table
          ref="timelineTable"
          :items-provider="timelineProvider"
          :fields="timelineFields"
          pagination="server"
          row-slot="in"
          search
        >
          <template #row="{ row }">
            <td class="no-wrap">
              {{ formatDate(row.EnteredAt) }}
            </td>
            <td>{{ row.PageTitle || row.RouteName || row.RoutePath }}</td>
            <td class="text-muted">
              {{ row.FromRouteName || row.FromRoutePath || '—' }}
            </td>
            <td>{{ formatDuration(row.DurationSeconds) }}</td>
            <td>{{ formatDuration(row.ActiveSeconds) }}</td>
            <td>{{ exitTypeLabel(row.ExitType) }}</td>
          </template>
        </v-table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { NavigationApi } from '@/api/navigation'
import { BCard, BTabs, BTab } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
  },
  data() {
    return {
      startDate: this.defaultStart(),
      endDate: this.today(),
      userType: null,
      activeTab: 0,
      screensTotalViews: 0,
      selectedUser: null,
      timelineScreenCount: 0,
      timelineActiveSeconds: 0,
      timelineDurationSeconds: 0,
      screensFields: [
        { key: 'PageTitle', name: 'Ekran', sortable: false },
        { key: 'ViewCount', name: 'Ziyaret', sortable: false },
        { key: 'UniqueUserCount', name: 'Tekil Kullanıcı', sortable: false },
        { key: 'AvgDurationSeconds', name: 'Ort. Süre', sortable: false },
        { key: 'AvgActiveSeconds', name: 'Ort. Aktif Süre', sortable: false },
        { key: 'TotalActiveSeconds', name: 'Toplam Aktif Süre', sortable: false },
      ],
      usersFields: [
        { key: 'UserFullName', name: 'Kullanıcı', sortable: false },
        { key: 'UserType', name: 'Tip', sortable: false },
        { key: 'ScreenViewCount', name: 'Ekran Sayısı', sortable: false },
        { key: 'SessionCount', name: 'Oturum', sortable: false },
        { key: 'TotalActiveSeconds', name: 'Toplam Aktif Süre', sortable: false },
        { key: 'TotalDurationSeconds', name: 'Toplam Süre', sortable: false },
        { key: 'LastSeen', name: 'Son Görülme', sortable: false },
      ],
      userButtons: [
        {
          key: 'timeline', icon: 'EyeIcon', variant: 'primary', text: 'Ekran Geçmişi', action: this.drillToUser,
        },
      ],
      flowFields: [
        { key: 'FromRouteName', name: 'Önceki Ekran', sortable: false },
        { key: 'ToRouteName', name: 'Gidilen Ekran', sortable: false },
        { key: 'Count', name: 'Geçiş Sayısı', sortable: false },
      ],
      timelineFields: [
        { key: 'EnteredAt', name: 'Giriş Saati', sortable: false },
        { key: 'PageTitle', name: 'Ekran', sortable: false },
        { key: 'FromRouteName', name: 'Önceki Ekran', sortable: false },
        { key: 'DurationSeconds', name: 'Toplam Süre', sortable: false },
        { key: 'ActiveSeconds', name: 'Aktif Süre', sortable: false },
        { key: 'ExitType', name: 'Çıkış', sortable: false },
      ],
    }
  },
  methods: {
    today() {
      return new Date().toISOString().slice(0, 10)
    },
    defaultStart() {
      const d = new Date()
      d.setDate(d.getDate() - 30)
      return d.toISOString().slice(0, 10)
    },
    // VTable ctx.Skip = sayfa numarası (1 tabanlı); backend satır ofseti bekler.
    paging(ctx) {
      const take = ctx.Take || 20
      const page = ctx.Skip || 1
      return { Skip: (page - 1) * take, Take: take, Search: ctx.QueryParam }
    },
    baseFilter() {
      return {
        StartDate: this.startDate,
        EndDate: this.endDate,
        UserType: this.userType,
      }
    },
    refreshTable(ref) {
      if (ref) {
        ref.setPage(1)
        ref.refresh()
      }
    },
    applyFilters() {
      this.selectedUser = null
      this.refreshTable(this.$refs.screensTable)
      this.refreshTable(this.$refs.usersTable)
      this.refreshTable(this.$refs.flowTable)
      this.refreshTable(this.$refs.timelineTable)
    },
    async screensProvider(ctx) {
      const ref = this.$refs.screensTable
      ref.setLoading(true)
      try {
        const res = await NavigationApi.ScreenStats({ ...this.baseFilter(), ...this.paging(ctx) })
        const d = res.data.Data || {}
        this.screensTotalViews = d.TotalViewCount || 0
        ref.setItems(d.Items || [])
        ref.setTotal(d.Count || 0)
      } catch (e) {
        ref.setItems([])
        ref.setTotal(0)
      } finally {
        ref.setLoading(false)
      }
    },
    async usersProvider(ctx) {
      const ref = this.$refs.usersTable
      ref.setLoading(true)
      try {
        const res = await NavigationApi.UserActivity({ ...this.baseFilter(), ...this.paging(ctx) })
        const d = res.data.Data || {}
        ref.setItems(d.Items || [])
        ref.setTotal(d.Count || 0)
      } catch (e) {
        ref.setItems([])
        ref.setTotal(0)
      } finally {
        ref.setLoading(false)
      }
    },
    async flowProvider(ctx) {
      const ref = this.$refs.flowTable
      ref.setLoading(true)
      try {
        const res = await NavigationApi.Flow({ ...this.baseFilter(), ...this.paging(ctx) })
        const d = res.data.Data || {}
        ref.setItems(d.Items || [])
        ref.setTotal(d.Count || 0)
      } catch (e) {
        ref.setItems([])
        ref.setTotal(0)
      } finally {
        ref.setLoading(false)
      }
    },
    async timelineProvider(ctx) {
      const ref = this.$refs.timelineTable
      if (!this.selectedUser) {
        ref.setItems([])
        ref.setTotal(0)
        return
      }
      ref.setLoading(true)
      try {
        const res = await NavigationApi.UserTimeline({
          UserId: this.selectedUser.UserId || null,
          CustomerCode: this.selectedUser.CustomerCode || null,
          StartDate: this.startDate,
          EndDate: this.endDate,
          ...this.paging(ctx),
        })
        const d = res.data.Data || {}
        this.timelineScreenCount = d.ScreenCount || 0
        this.timelineActiveSeconds = d.TotalActiveSeconds || 0
        this.timelineDurationSeconds = d.TotalDurationSeconds || 0
        ref.setItems(d.Items || [])
        ref.setTotal(d.Count || 0)
      } catch (e) {
        ref.setItems([])
        ref.setTotal(0)
      } finally {
        ref.setLoading(false)
      }
    },
    drillToUser(item) {
      this.selectedUser = item
      this.activeTab = 3
      this.$nextTick(() => this.refreshTable(this.$refs.timelineTable))
    },
    formatDuration(totalSeconds) {
      const sec = Number(totalSeconds) || 0
      if (sec < 60) return `${sec} sn`
      const m = Math.floor(sec / 60)
      const s = sec % 60
      if (m < 60) return `${m} dk ${s} sn`
      const h = Math.floor(m / 60)
      const mm = m % 60
      return `${h} sa ${mm} dk`
    },
    formatDate(value) {
      if (!value) return '—'
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return value
      const p = n => String(n).padStart(2, '0')
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    userTypeLabel(type) {
      if (type === 2 || type === 'Customer') return 'Müşteri'
      if (type === 1 || type === 'Internal') return 'Personel'
      return 'Anonim'
    },
    exitTypeLabel(type) {
      if (type === 1) return 'Geçiş'
      if (type === 2) return 'Yenileme'
      if (type === 3) return 'Kapatma'
      return '—'
    },
  },
}
</script>
